import { render, staticRenderFns } from "./SVGBrush.vue?vue&type=template&id=696f54da&scoped=true&"
import script from "./SVGBrush.vue?vue&type=script&lang=js&"
export * from "./SVGBrush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696f54da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('696f54da')) {
      api.createRecord('696f54da', component.options)
    } else {
      api.reload('696f54da', component.options)
    }
    module.hot.accept("./SVGBrush.vue?vue&type=template&id=696f54da&scoped=true&", function () {
      api.rerender('696f54da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGBrush.vue"
export default component.exports